import { useMemo } from 'react'

import { useIsMobile } from './useIsMobile'

// https://hhgdev.atlassian.net/browse/HHD-6479
// excluded_sponsor = true + is_sponsor = true
// excluded_sponsor = true + sponsor có data
export function useMastheadAdEnable(
  mastheadAdArticle: Partial<AdsOnArticle & AdsExcludeSponsored>,
  hasSponsored?: boolean,
) {
  const isMobile = useIsMobile()
  const {
    ads_on_articles_for_mobile,
    ads_on_articles_for_desktop,
    ads_exclude_sponsored_mobile,
    ads_exclude_sponsored_desktop,
  } = mastheadAdArticle || {}

  return useMemo(() => {
    if (isMobile) {
      if (ads_exclude_sponsored_mobile && hasSponsored) {
        return false
      }
      return ads_on_articles_for_mobile
    }

    if (ads_exclude_sponsored_desktop && hasSponsored) {
      return false
    }
    return ads_on_articles_for_desktop
  }, [
    isMobile,
    ads_on_articles_for_mobile,
    ads_exclude_sponsored_mobile,
    ads_on_articles_for_desktop,
    ads_exclude_sponsored_desktop,
    hasSponsored,
  ])
}
